module.exports = __webpack_public_path__ + "static/media/coriander.f7b0ba7b.webp";